import { colors } from '@flowio/design-tokens';
var borderColor = {
  button: {
    outline: {
      negative: {
        active: colors.red[700],
        base: colors.red[500],
        disabled: colors.neutral[400],
        hover: colors.red[400],
        focused: colors.red[400]
      },
      neutral: {
        active: colors.neutral[500],
        base: colors.neutral[400],
        disabled: colors.neutral[400],
        hover: colors.neutral[300],
        focused: colors.neutral[300]
      },
      positive: {
        active: colors.green[700],
        base: colors.green[500],
        disabled: colors.neutral[400],
        hover: colors.green[400],
        focused: colors.green[400]
      },
      primary: {
        active: colors.blue[700],
        base: colors.blue[500],
        disabled: colors.neutral[400],
        hover: colors.blue[400],
        focused: colors.blue[400]
      },
      warning: {
        active: colors.yellow[700],
        base: colors.yellow[500],
        disabled: colors.neutral[400],
        hover: colors.yellow[400],
        focused: colors.yellow[400]
      }
    },
    solid: {
      negative: {
        active: colors.red[700],
        base: colors.red[500],
        disabled: colors.neutral[400],
        hover: colors.red[400],
        focused: colors.red[400]
      },
      neutral: {
        active: colors.neutral[500],
        base: colors.neutral[400],
        disabled: colors.neutral[400],
        hover: colors.neutral[300],
        focused: colors.neutral[300]
      },
      positive: {
        active: colors.green[700],
        base: colors.green[500],
        disabled: colors.neutral[400],
        hover: colors.green[400],
        focused: colors.green[400]
      },
      primary: {
        active: colors.blue[700],
        base: colors.blue[500],
        disabled: colors.neutral[500],
        hover: colors.blue[400],
        focused: colors.blue[400]
      },
      warning: {
        active: colors.yellow[700],
        base: colors.yellow[500],
        disabled: colors.neutral[400],
        hover: colors.yellow[400],
        focused: colors.yellow[400]
      }
    }
  },
  checkbox: {
    negative: {
      checked: colors.red[500],
      checkedDisabled: colors.neutral[500],
      unchecked: colors.red[500],
      uncheckedDisabled: colors.neutral[500]
    },
    neutral: {
      checked: colors.blue[600],
      checkedDisabled: colors.neutral[500],
      unchecked: colors.neutral[600],
      uncheckedDisabled: colors.neutral[500]
    }
  },
  banner: {
    negative: colors.red[600],
    positive: colors.green[500],
    info: colors.blue[600],
    neutral: colors.neutral[900],
    warning: colors.yellow[500]
  },
  notchedOutline: {
    base: colors.neutral[500],
    disabled: colors.neutral[200],
    focused: colors.blue[600],
    negative: colors.red[500],
    positive: colors.green[500],
    warning: colors.yellow[500]
  },
  tabButton: {
    base: colors.blue[400],
    active: colors.blue[600]
  },
  radioButton: {
    base: colors.blue[600],
    disabled: '#d8dde3'
  }
};
export default borderColor;